import './evento-cta.scss';

/**
 * version    1.0
 * class      <type> (evento-cta)
 * classdesc  Component that manage evento cta
 */
export class EventoCta {}
